MuseModel = require("../base.coffee")

# model representing an individual type of resource
class IndividualModel extends MuseModel
    # type of individual model to request
    model_type: coat.prop(null)

    constructor: (opts) ->
        if "requestErrorMessage" not of opts then opts.requestErrorMessage = "There was a request error for this model; properties not available"
        super opts

    url: () ->
        return @baseURL + "/api/#{@model_type()}/#{@id()}"

    getTrackProps: () ->
        throw("You can't call get tracks props on an individual model without explicitly defining props.")

module.exports = IndividualModel



// WEBPACK FOOTER //
// ./node_modules/musecoreui/models/individual/base_individual_model.coffee